/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const desktopNavStyle = {
  desktopNav: {
    listStyle: "none",
    height: "100%",
    alignItems: "center",
    margin: 0,
    padding: 0,
  },
};
